import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CampaignCardDto } from "../utilities/backend/client";
import { getUrlBlobContainerImage } from "../resources/imageConstants";

interface CampaignCardProps {
  campaign: CampaignCardDto | undefined;
  investedAmount: string | undefined;
  investedDate: string | undefined;
  status: string | undefined;
}

const CampaignCardDetail: React.FC<CampaignCardProps> = ({ campaign }) => {
  const theme = useTheme();

  const imageFileName = campaign?.tileImageFileName || campaign?.imageFileName;
  const isXl = useMediaQuery(theme.breakpoints.up(1200));
  const isLg = useMediaQuery(theme.breakpoints.up(1400));
  const isXxl = useMediaQuery(theme.breakpoints.up(1900));

  let maxLength = 170;

  if (isXxl) {
    maxLength = 200;
  } else if (isLg) {
    maxLength = 150;
  } else if (isXl) {
    maxLength = 90;
  }

  const description = campaign?.description || "";
  const truncatedDescription =
    description.length > maxLength
      ? description.substring(0, maxLength) + "..."
      : description;

  return (
    <Card sx={{ borderRadius: "16px" }}>
      <CardMedia
        sx={{ height: 170, borderRadius: "16px 16px 0 0" }}
        title={campaign?.name!}
        component="img"
        src={getUrlBlobContainerImage(imageFileName!)}
      />
      <CardContent sx={{ paddingBottom: 0 }}>
        <Typography
          gutterBottom
          sx={{
            fontFamily: "Poppins",
            fontSize: 16,
            fontWeight: 700,
            color: "#191919",
            lineHeigh: "28.8px",
            overflow: "hidden",
          }}
        >
          {campaign?.name}
        </Typography>
        <p
          dangerouslySetInnerHTML={{
            __html: truncatedDescription ? truncatedDescription : "",
          }}
          style={
            {
              fontFamily: "Poppins",
              fontSize: 14,
              fontWeight: 400,
              color: "#656565",
              lineHeight: "17.09px",
              maxHeight: "130px",
              minHeight: "130px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            } as React.CSSProperties
          }
        />
      </CardContent>
    </Card>
  );
};

export default CampaignCardDetail;
